@switch (conversationType) {
  @case ("Chat") {
    <app-basic-celo-avatar
      [name]="conversationName"
      [userId]="otherParticipantUserId"
      [size]="size"
      [badgeSize]="badgeSize"
      [isWorkspaceVerified]="isWorkspaceVerified"
      [isIdentityVerified]="isIdentityVerified"
      [isProfessionVerified]="isProfessionVerified"
    />
  }
  @case ("TeamChat") {
    <app-roles-icon
      [backgroundSize]="size + 'px'"
      [size]="rolesIconSize + 'px'"
    />
  }
  @default {
    <app-celo-avatar
      [width]="size"
      [height]="size"
      [type]="conversationType"
      [conversationPictureUri]="this.conversationPhotoUrl"
    ></app-celo-avatar>
  }
}
